// extracted by mini-css-extract-plugin
module.exports = {"map":"styles_map_3WvusF4d6EcjaoCi465YYd"};